import {JsonObject, JsonProperty} from 'json2typescript';

@JsonObject('DynamicValueFilter')
export class DynamicValueFilter {

    @JsonProperty('min_date',String,true)
    min_date = '';
    @JsonProperty('max_date',String,true)
    max_date = '';
    @JsonProperty('keys_filter',[String],true)
    keys_filter:string[] = [];
}
